import UI5Helpers from '../helpers/UI5Helpers';

export default {
    updated() {
        UI5Helpers.manipulateColorPickerMainColor((mainColor) => {
            const style = mainColor.style;
            style.transform = 'scale(0.4)';
            style.margin = '-75px';
            mainColor.querySelector(
                '.ui5-color-picker-circle'
            ).style.transform = 'scale(2)';
        });
        UI5Helpers.simplifyColorPickers();
    },
};
